import React from "react";
import classes from "./About.module.css";
import { Heading, Text, Button, SectionHeading } from "components/common";
import { useNavigate } from "react-router-dom";

const About = ({ frontendInfo }) => {
  const navigate = useNavigate();



  return (
    <div className={classes.aboutPage}>
      {/* Hero Section */}
      <section className={classes.heroSection}>
        <div className={classes.heroContent}>
          <Heading>Who We Are</Heading>
          <Text xl2 primitive0>
            {` ${frontendInfo?.site_name} was established to bridge the gap between large-scale institutional investment expertise and personalized financial service. Our founders recognized that many investors, whether new to the market or seasoned were underserved by one-size-fits-all solutions. Our purpose is simple: to help our clients make money.
            We approach every investment with a profit-first mindset, combining market insight, disciplined execution, and risk-aware strategies to generate consistent, sustainable growth.`}
          </Text>
          <Button btnPrimary onClick={() => navigate("/sign-up")}>
            Start Investing
          </Button>
        </div>
      </section>

      {/* Brief Section */}
      <section className={classes.briefSection}>
        <div className={classes.briefContent}>
          <Text xl2>
            Our mission is to deliver strong, reliable returns for our clients through intelligent, data-driven investment strategies. We believe that success in the financial markets is the result of preparation, precision, and decisive action. Every move we make is aimed at maximizing profitability while safeguarding our clients’ capital.          </Text>
          {/* <Text xl2>
            Our focus is simple: helping our clients reach their financial aspirations.
          </Text>
          <Text xl2>
            When we speak of our achievements, we're really celebrating the trust and success of those who choose to invest with us.
          </Text> */}
        </div>
      </section>

      {/* Mission Section */}
      <section className={classes.missionSection}>
        <div className={classes.missionContent}>
          <div className={classes.missionText}>
            <Heading xl5>What We Do</Heading>
            <Text xl2>
              We provide a full suite of investment and wealth management services designed to adapt to an ever-changing financial landscape.
            </Text>
            <Text xl2>
              {`From portfolio management and asset allocation to long-term wealth planning, ${frontendInfo?.site_name} offers a full spectrum of investment services. We work closely with our clients to design strategies that balance growth potential with prudent risk management. `}           </Text>
          </div>
          <div className={classes.missionStats}>
            <div className={classes.statItem}>
              <Heading xl6>12+</Heading>
              <Text xl>Years of Experience</Text>
            </div>
            <div className={classes.statItem}>
              <Heading xl6>50K+</Heading>
              <Text xl>Active Investors</Text>
            </div>
            <div className={classes.statItem}>
              <Heading xl6>$20M+</Heading>
              <Text xl>Assets Managed</Text>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className={classes.valuesSection}>
        <div className={classes.valuesHeader}>
          <Heading xl5>What We Stand For</Heading>
        </div>
        <div className={classes.valuesGrid}>
          <div className={classes.valueCard}>
            <Heading xl3>Transparency</Heading>
            <Text xl>
              We believe in complete openness about our processes, fees, and investment strategies.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Innovation</Heading>
            <Text xl>
              Constantly evolving our platform with cutting-edge technology to serve you better.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Security</Heading>
            <Text xl>
              Your investments are protected with industry-leading security measures.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Education</Heading>
            <Text xl>
              Empowering investors through comprehensive learning resources and support.
            </Text>
          </div>
        </div>
      </section>

      {/* Team Section */}


      {/* CTA Section */}
      <section className={classes.ctaSection}>
        <div className={classes.ctaContent}>
          <Heading xl5>Ready to Start Your Investment Journey?</Heading>
          <Text xl2>
            Join thousands of successful investors who trust us with their financial future.
          </Text>
          <Button btnPrimary onClick={() => navigate("/sign-up")}>
            Get Started Now
          </Button>
        </div>
      </section>
    </div>
  );
};

export default About;
